import { useState } from "react";
import { navSections } from "@/mocks/gossip";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50">
      {/* utility ticker strip */}
      <div className="bg-primary-600 text-background-50">
        <div className="container-x flex items-center gap-3 overflow-hidden py-1.5 text-xs whitespace-nowrap">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-2.5 py-0.5 font-semibold">
            <i className="ri-flashlight-fill text-[13px] text-accent-300"></i>
            瓜田速报
          </span>
          <p className="truncate opacity-90">
            实锤集合已按今晚时间轴归档 · 场控麦原声分段已更新 · 想吃哪一瓜，先按目录挑
          </p>
          <span className="ml-auto hidden shrink-0 opacity-80 sm:inline">更新于 2026.09.07 21:40</span>
        </div>
      </div>

      {/* main nav */}
      <nav className="border-b border-background-200/80 bg-background-50/90 backdrop-blur">
        <div className="container-x flex h-16 items-center gap-6">
          {/* brand */}
          <a href="#top" className="flex items-center gap-2.5">
            <span className="grid h-9 w-9 place-items-center rounded-xl bg-accent-500 text-lg text-background-50">
              <i className="ri-arrow-left-right-line"></i>
            </span>
            <span className="leading-none">
              <span className="block font-heading text-lg font-extrabold tracking-tight text-foreground-950">
                吃瓜<span className="text-primary-600">网爆</span>
              </span>
              <span className="mt-1 block text-[11px] text-foreground-400">猛料·按类码好</span>
            </span>
          </a>

          {/* desktop links */}
          <div className="hidden flex-1 items-center justify-center gap-1 md:flex">
            {navSections.map((s) => (
              <a
                key={s.href}
                href={s.href}
                className="rounded-md px-3 py-2 text-sm text-foreground-600 transition-colors hover:bg-background-100 hover:text-foreground-950 whitespace-nowrap"
              >
                {s.label}
              </a>
            ))}
          </div>

          <div className="ml-auto flex items-center gap-2 md:ml-0">
            {/* mock search */}
            <button
              type="button"
              aria-label="搜索瓜料"
              className="hidden w-44 items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-2 text-sm text-foreground-400 transition-colors hover:border-primary-200 lg:flex"
            >
              <i className="ri-search-line text-base"></i>
              <span className="truncate">搜人名 / 事件 / 话题</span>
            </button>
            <a
              href="#top"
              className="hidden items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap sm:inline-flex"
            >
              <i className="ri-megaphone-line text-base"></i>
              我要报料
            </a>
            {/* hamburger */}
            <button
              type="button"
              aria-label="菜单"
              onClick={() => setOpen((v) => !v)}
              className="grid h-10 w-10 place-items-center rounded-lg border border-background-200 text-foreground-700 md:hidden"
            >
              <i className={`ri-${open ? "close-line" : "menu-line"} text-xl`}></i>
            </button>
          </div>
        </div>

        {/* mobile panel */}
        {open && (
          <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
            <div className="grid grid-cols-2 gap-1">
              {navSections.map((s) => (
                <a
                  key={s.href}
                  href={s.href}
                  onClick={() => setOpen(false)}
                  className="rounded-lg px-3 py-2.5 text-sm text-foreground-600 hover:bg-background-100"
                >
                  {s.label}
                </a>
              ))}
            </div>
            <a
              href="#top"
              className="mt-3 flex items-center justify-center gap-1.5 rounded-lg bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 whitespace-nowrap"
            >
              <i className="ri-megaphone-line text-base"></i>我要报料
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}